/**
 * Partner colleges configuration.
 *
 * To add a new college: add an entry to this array.
 * To add a real logo: set logoUrl to the image URL (hosted on S3 or CDN).
 * When logoUrl is null, the UI renders a styled avatar with the abbreviation and brand color.
 *
 * This file is the single source of truth for college data across the entire app
 * (About page, Booking form, Landing page, etc).
 */

const colleges = [
  {
    id: 'gcu-001',
    name: 'Grand Canyon University',
    abbreviation: 'GCU',
    location: 'Phoenix, AZ',
    color: '#522D80',
    logoUrl: '/images/colleges/gcu.png',
    logoScale: 1.3,
    description: 'Active cybersecurity program with hands-on training, industry partnerships, and a strong emphasis on practical skills that translate directly to the field.',
    active: true,
  },
  {
    id: 'asu-001',
    name: 'Arizona State University',
    abbreviation: 'ASU',
    location: 'Tempe, AZ',
    color: '#8C1D40',
    logoUrl: '/images/colleges/asu.png',
    description: 'One of the nation\'s largest and top-ranked cybersecurity programs, producing graduates who are highly sought after by Fortune 500 companies and government agencies.',
    active: true,
  },
  {
    id: 'nau-001',
    name: 'Northern Arizona University',
    abbreviation: 'NAU',
    location: 'Flagstaff, AZ',
    color: '#003466',
    logoUrl: '/images/colleges/nau.png',
    description: 'Strong applied computing and cybersecurity program in the heart of northern Arizona with a focus on hands-on learning and industry readiness.',
    active: true,
  },
  {
    id: 'ua-001',
    name: 'University of Arizona',
    abbreviation: 'UOA',
    location: 'Tucson, AZ',
    color: '#CC0033',
    logoUrl: '/images/colleges/uofa.png',
    logoScale: 1.3,
    description: 'Leading information security and digital forensics program with dedicated research labs and a track record of producing elite cybersecurity talent.',
    active: true,
  },
  {
    id: 'uop-001',
    name: 'University of Phoenix',
    abbreviation: 'UOP',
    location: 'Phoenix, AZ',
    color: '#8B0000',
    logoUrl: '/images/colleges/uop.png',
    logoScale: 1.3,
    description: 'Flexible cybersecurity and information technology programs designed for working adults, with a strong emphasis on practical skills and industry-aligned curriculum.',
    active: true,
  },
  {
    id: 'uat-001',
    name: 'University of Advancing Technology',
    abbreviation: 'UAT',
    location: 'Tempe, AZ',
    color: '#1a1a2e',
    logoUrl: '/images/colleges/uat.jpg',
    description: 'Technology-focused university with dedicated cybersecurity and network security degree programs, known for immersive project-based learning and close industry ties.',
    active: true,
  },
  {
    id: 'mcc-001',
    name: 'Maricopa Community Colleges',
    abbreviation: 'MCC',
    location: 'Phoenix, AZ',
    color: '#AC1F2D',
    logoUrl: '/images/colleges/maricopa.jpg',
    description: 'One of the largest community college districts in the nation, with multiple campuses offering NSA-designated cybersecurity programs and hands-on technical training across the Phoenix metro area.',
    active: true,
  },
  {
    id: 'erau-001',
    name: 'Embry-Riddle Aeronautical University',
    abbreviation: 'ERAU',
    location: 'Prescott, AZ',
    color: '#003E7E',
    logoUrl: '/images/colleges/embry-riddle.png',
    description: 'Globally recognized STEM university with a dedicated Cyber Intelligence and Security program, producing graduates skilled in aviation, aerospace, and critical-infrastructure cybersecurity.',
    active: true,
  },
];

export const getActiveColleges = () => colleges.filter(c => c.active);
export const getCollegeById = (id) => colleges.find(c => c.id === id);
export default colleges;
